import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "#1E164B",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6Zm6.827 8.927c1.473.394 2.567 1.196 2.567 2.61 0 1.344-.936 2.313-2.244 2.63-.342.083-.614.368-.614.72v.18a.496.496 0 0 1-.992 0v-.215c0-.354-.264-.646-.602-.75-.972-.302-1.657-.964-1.932-1.782-.154-.457.253-.855.736-.855.485 0 .856.437 1.161.815.265.328.708.54 1.293.54.919 0 1.43-.539 1.43-1.195 0-.51-.365-.933-1.226-1.167l-1.137-.32c-1.983-.51-2.333-1.707-2.333-2.48 0-1.234.86-2.154 2.034-2.512.324-.1.576-.379.576-.717v-.183a.496.496 0 1 1 .992 0v.174c0 .34.26.62.587.714.941.269 1.618.91 1.871 1.779.133.457-.273.847-.75.847-.474 0-.827-.424-1.134-.793l-.03-.036c-.23-.275-.591-.44-1.04-.44-.773 0-1.327.482-1.327 1.124 0 .262.073.772 1.05 1.035l1.064.277Z"
    }, null, -1)
  ]))]))
}
export default { render: render }